import React, { useState } from 'react';
import { connect } from 'react-redux';
import { HtmlWrapper } from '../../components/HtmlWrapper';
import './EmptySpace.css'

const EmptySpace = (props) => {
    const { content } = props.element;
    return (
        <React.Fragment>
            <tr>
                <td >
                    <HtmlWrapper content={content} />
                </td>
            </tr>
        </React.Fragment>
    )
}
function mapStateToProps(state) {
 /*    return state; */
}

export default /* connect(mapStateToProps)( */EmptySpace/* ); */